"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { StatusCard } from "@/components/ui/StatusCard";
import { reloadOnceForChunkError } from "@/lib/chunks/chunkErrors";

// Same pattern as safari/error.tsx — React error boundaries catch render
// errors before window.onerror, so posthog.captureException must be called
// explicitly alongside console.error (react AGENTS.md).
export default function CountriesError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
    posthog.captureException(error);
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <main className="flex-1 flex items-center justify-center px-6 py-14">
      <Container size="narrow">
        <StatusCard
          tone="error"
          title="Something went wrong"
          body="We hit an unexpected error loading this page. Please try again."
          actions={
            <>
              <Button onClick={() => unstable_retry()}>Try again</Button>
              <Button variant="secondary" href="/">
                Back to home
              </Button>
            </>
          }
        />
      </Container>
    </main>
  );
}
